(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name TrabajosController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('TrabajosController', TrabajosController);

    TrabajosController.$inject = ["TrabajosService","$timeout","$location",'$anchorScroll'];

    function TrabajosController(TrabajosService,$timeout,$location,$anchorScroll)
    {
        var vm = this;
        vm.pag = 0;
        vm.maxPages = 0;
        vm.articulos = [];
        vm.loading = false;
        vm.getTrabajos = function(){
            vm.loading = true;
            TrabajosService.getTrabajos(vm,function(data){
                vm.loading = false;
                vm.articulos = data.articulos;
                vm.maxPages = data.maxPages;
                if(vm.pag>0){
                    $("html, body").animate({ scrollTop: $('.filters-news').offset().top }, 1000);
                }
            },function(){vm.loading = false;});
        };

        vm.next = function(){
            vm.pag++;
            vm.getTrabajos();
        }
        vm.prev = function(){
            vm.pag--;
            vm.getTrabajos();
        }
    }


})();